import type { NetworkLossDetailSelectionParams, NetworkVolDetail } from '@gozoki/api-types'
import { keepPreviousData, type UseQueryResult, useQuery } from '@tanstack/react-query'
import { buildNetworkLossDetailQueryKey } from '../queries/network-loss-detail-params'
import { fetchNetworkVolDetail } from '../queries/networkVolDetail.queries'

export const useNetworkVolDetail = (
  selection: NetworkLossDetailSelectionParams,
  enabled = true,
): UseQueryResult<NetworkVolDetail, unknown> =>
  useQuery({
    queryKey: buildNetworkLossDetailQueryKey('get-network-vol-detail', selection),
    queryFn: () => fetchNetworkVolDetail(selection),
    placeholderData: keepPreviousData,
    enabled,
  })
